module.exports = __webpack_public_path__ + "static/img/fyCertificate1.ff85a69.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/fyImg/fyCertificate1.jpg
// module id = xBNF
// module chunks = 3